import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import useRequests from "../../../Utils/useRequests"

// users
import user1 from "../../../assets/images/users/avatar-1.jpg"
import LanguageDropdown from "../TopbarDropdown/LanguageDropdown"
import CryptoJS from "crypto-js"
import useDecryptedAuth from "../../../Utils/useDecryptedAuth"
import i18next from "i18next"

const NotificationsMenu = props => {
  const { getRequest, postRequest, postRequestByFormData } = useRequests()

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const decryptedAuth = useDecryptedAuth()
  const [notifications, setNotifications] = useState([])

  const [Count, setCount] = useState(0)
  const handleLoadGetNotifications = async () => {
    const res = await getRequest("get-notifications")
    if (res && res.code === 200) {
      let filteredData = res.data.filter(item => item.deleted_at == null)

      setNotifications(filteredData)

      const count = filteredData.filter(item => item.read == "false")
      setCount(count.length)
    } else {
      setNotifications([])
    }
  }

  const [username, setusername] = useState({ fullname: "Admin", symbol: "A" })
  React.useEffect(() => {
    handleLoadGetNotifications()
    let capitalizedUsername = decryptedAuth.username.replace(
      /\b\w/g,
      function (char) {
        return char.toUpperCase()
      },
    )

    let words = decryptedAuth.username.split(" ")
    let firstCharacters = words.map(word => word.charAt(0).toUpperCase())
    let combined = firstCharacters.join("")

    setusername({
      ...username,
      fullname: capitalizedUsername,
      symbol: combined,
    })
  }, [])

  const handleNotificationAction = async (e, note) => {
    const jsonpar = JSON.stringify({
      n_id: note.n_id,
    })
    const res = await postRequest("update-notification", jsonpar)
    if (res && res.code === 200) {
      await handleLoadGetNotifications()
    }

    // Close the dropdown after an action. This is often desired behavior.
    setMenu(false)

    if (note.redirect_link) {
      props.history.push(note.redirect_link)
    }
  }

  const handleAllNotificationAction = async () => {
    const res = await getRequest("update-all-notification")
    if (res && res.code === 200) {
      await handleLoadGetNotifications()
    }

    // Close the dropdown after an action. This is often desired behavior.
    // setMenu(false);
  }

  return (
    <React.Fragment>
      {/* <LanguageDropdown /> */}
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item position-relative" // make the parent relative
          id="page-header-user-dropdown"
          tag="button"
        >
          <i
            className="bx bx-bell"
            style={{
              fontSize: "26px",
              color: "#ffffff",
            }}
          ></i>

          {Count > 0 ? (
            <span
              style={{
                position: "absolute",
                top: "15px", // move it slightly down
                right: "1px", // adjust horizontal if needed
                color: "#fff",
                backgroundColor: "red",
                borderRadius: "50%",
                padding: "2px 6px",
                fontSize: "10px",
                fontWeight: "600",
                lineHeight: "1",
                animation: "blink 1s infinite",
              }}
            >
              {Count}
            </span>
          ) : (
            ""
          )}
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-end"
          style={{
            minWidth: "300px",
            maxHeight: "350px",
            padding: "0.5rem",
          }}
        >
          <div
            style={{
              maxHeight: "250px",
              overflowY: "auto",
            }}
          >
            {notifications.length === 0 ? (
              <span className="dropdown-item text-center">
                {i18next.t("No Notifications")}
              </span>
            ) : (
              notifications
                .slice(-5) // get only the last 5 notifications
                .map(note => (
                  <div
                    key={note.n_id}
                    className="dropdown-item d-flex align-items-start justify-content-between"
                    style={{ cursor: "pointer", padding: "0.5rem 1rem" }}
                    onClick={e => handleNotificationAction(e, note)} // Attach action here
                  >
                    {/* Notification content */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        flex: 1,
                      }}
                    >
                      {/* Read/Unread dot */}
                      <span
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: note.read == "true" ? "#ccc" : "red",
                          display: "inline-block",
                          marginRight: "10px",
                          marginTop: "6px",
                          flexShrink: 0,
                        }}
                      ></span>

                      <div
                        style={{
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <h6
                          style={{
                            margin: "0",
                            fontSize: "14px",
                            fontWeight: note.read == "true" ? "normal" : "600",
                          }}
                        >
                          {localStorage.getItem("I18N_LANGUAGE")=="eng"?note.subject:note.subject_sp}
                        </h6>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "12px",
                            color: "#555",
                          }}
                        >
                          {localStorage.getItem("I18N_LANGUAGE")=="eng"?note.description:note.description_sp}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
            )}
          </div>

          <div className="dropdown-divider" />

          {/* Fixed View All button */}
          <Link
            to="/notification"
            className="dropdown-item text-center mt-auto"
            style={{ fontWeight: "600", color: "#29662f", fontSize: "12px" }}
          >
            {i18next.t("View All")}
          </Link>
          <Link
            to="#"
            className="dropdown-item text-center mt-auto"
            style={{ fontWeight: "600", color: "#29662f", fontSize: "12px" }}
            // Ensure this link also stops propagation, or relies on the DropdownMenu's handler
            onClick={() => {
              handleAllNotificationAction()
            }}
          >
            {i18next.t("Mark All as Read")}
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

NotificationsMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(NotificationsMenu)),
)
